import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {omit} from 'lodash';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation deleteReportShareMutation($input: DeleteReportShareInput!) {
		deleteReportShare(input: $input) {
			deletedShareId
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_DELETE',
			parentID: input.reportId,
			connectionKeys: [
				{
					key: 'Report_shares',
				},
			],
			pathToConnection: ['report', 'share'],
			deletedIDFieldName: 'deletedShareId',
		},
	];
}

function getOptimisticResponse(input) {
	return {
		deleteReportShare: {
			deletedShareId: input.id,
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Report Share Deleted');

	const cleanedInput = omit(input, []);

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...cleanedInput}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
